import { render, staticRenderFns } from "./reports-legend-bar-chart2.vue?vue&type=template&id=1d79fb03&scoped=true"
import script from "./reports-legend-bar-chart2.vue?vue&type=script&lang=js"
export * from "./reports-legend-bar-chart2.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-bar-chart2.vue?vue&type=style&index=0&id=1d79fb03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79fb03",
  null
  
)

export default component.exports